import React, { useEffect, useRef, useState } from 'react';
import { MergeFieldDropdown } from './MergeFieldDropdown';
import { SMSPhoneMockup } from './SMSPhoneMockup';
import { SMS_MAX_SEGMENTS, SMS_SEGMENT_LENGTH } from './sms-constants';
import styles from './SendMessageStep.module.css';

interface SMSSetupProps {
  defaultValue?: string;
  onChange?: (value: string) => void;
}

const MAX_CHARS = SMS_MAX_SEGMENTS * SMS_SEGMENT_LENGTH;

export const SMSSetup: React.FC<SMSSetupProps> = ({ defaultValue = '', onChange }) => {
  const [text, setText] = useState(defaultValue);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const characterCount = text.length;
  const segmentCount = Math.min(Math.ceil(characterCount / SMS_SEGMENT_LENGTH) || 1, SMS_MAX_SEGMENTS);

  useEffect(() => {
    setText(defaultValue);
  }, [defaultValue]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value.slice(0, MAX_CHARS);
    setText(value);
    onChange?.(value);
  };

  const handleInsertMergeField = (token: string) => {
    const textarea = textareaRef.current;
    const start = textarea?.selectionStart ?? text.length;
    const end = textarea?.selectionEnd ?? text.length;
    const newText = (text.slice(0, start) + token + text.slice(end)).slice(0, MAX_CHARS);
    const cursorPos = Math.min(start + token.length, MAX_CHARS);
    setText(newText);
    onChange?.(newText);
    requestAnimationFrame(() => {
      textarea?.focus();
      textarea?.setSelectionRange(cursorPos, cursorPos);
    });
  };

  return (
    <div className={styles.smsTab}>
      <div className={styles.smsFormPane}>
        <fieldset>
          <legend>Message</legend>
          <textarea
            ref={textareaRef}
            value={text}
            onChange={handleChange}
            rows={8}
            maxLength={MAX_CHARS}
            placeholder="Enter SMS message text..."
          />
          <footer>
            <small>
              {segmentCount} message{segmentCount !== 1 ? 's' : ''}
            </small>
            <small>
              {characterCount} / {MAX_CHARS}
            </small>
          </footer>
        </fieldset>
        <MergeFieldDropdown onInsert={handleInsertMergeField} />
      </div>
      <div className={styles.smsPreviewPane}>
        <SMSPhoneMockup text={text} />
      </div>
    </div>
  );
};
